import React from 'react';

import {
  appClaroPay,
  googlePlay,
  appStore,
  appGallery
} from '../../../../assets/images';
import classes from './PrimarySlide.module.css';

const PrimarySlide = () => {
  return (
    <div className={classes.mainCointeSlide}>
      <div className={classes.columnRight}>
        <img className={classes.imageSlide} src={appClaroPay} alt="App Claro Pay" />
      </div>
      <div className={classes.columnCenter}>
        <div className={classes.mainTitle}>
          <h1 className="card-heading" >Paga, envía y recibe dinero,</h1>
          <b className="sub-header">cuando quieras, desde donde quieras.</b>
        </div>
        <div className={classes.description}>
          <div className={classes.descText}>Descarga la App</div>
          <div>
            <a href="https://play.google.com/store/apps/details?id=com.globalhitss.claro.pay&referrer=utm_source%3Dlanding%26utm_medium%3Dheropage%26utm_campaign%3Dlanding" target="_blank" rel="noreferrer" >
              <img className={classes.imageStore} src={googlePlay} alt="Google Paly" />
            </a>
            <a href="https://apps.apple.com/mx/app/claro-pay/id1502765283" target="_blank" rel="noreferrer">
              <img className={classes.imageStore} src={appStore} alt="App Store" />
            </a>
            <img className={classes.imageStore} src={appGallery} alt="App Gallery" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrimarySlide;
